import { media, styled } from '@styles';

import { Button } from '@components/atoms/Button';

export const List = styled.div<{ loading: boolean }>`
  display: grid;
  grid-template-columns:
    minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)
    minmax(0, 1fr);
  grid-gap: 2em;
  opacity: ${(props) => (props.loading ? 0.5 : 1)};
  transition: opacity 0.3s ease;
  margin: auto 3em;
  ${media.mediumScreen`
    margin: auto;
  `}
  ${media.smMediumScreen`
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    grid-gap: 1rem;
    margin: auto;
  `}
  ${media.smallScreen`
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-gap: 1rem;
    margin: auto;
  `}
`;

export const Loader = styled.div`
  text-align: center;
  margin: 2.5rem 0;
`;

export const ShowMoreButton = styled(Button)`
  &.showmore {
    width: 320px;
    height: 68px;
    font-size: ${(props) => props.theme.typography.smallFontSize};
    line-height: ${(props) => props.theme.typography.smallFontSize};
    margin: auto;
    margin-bottom: 32px;
    grid-column-start: 2;
    grid-column-end: 2;
    ${media.largeScreen`
      width: 200px;
      height: 48px;
    `}
    ${media.smMediumScreen`
      grid-column-start: 1;
      grid-column-end: none;
    `}
  }
`;

export const BorderDiv = styled.div`
  width: 100%;
  border-bottom: 1px solid #cccccc;
  margin: 80px 0 47px;
  ${media.largeScreen`
    margin: 64px 0 30px;
  `}
  ${media.mediumScreen`
    margin: 80px 0 30px;
  `}
  ${media.xSmallScreen`
    margin: 40px 0 20px;
  `}
`;
